module.exports = __webpack_public_path__ + "static/index/img/baikal-200.b8b6c216.jpg";